export const link = {
  color: 'black',
}
